<template>
  <div>
    <Head title="Regjistrimi i barazimit" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/admin/financat/barazimet-me-shites">Barazimet me shitës</Link>
      <span class="text-indigo-400 font-medium">/</span> Regjistro
    </h1>
    <div class="max-w-lg bg-white rounded-md shadow overflow-hidden">
      <form>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">

          <div class="pb-8 pr-6 w-full">
            <label class="form-label">Biznesi shitës</label>
            <Multiselect
              v-model="form.business_id"
              :options="filterBusinesses.options"
              :close-on-select="true"
              :searchable="true"
              :create-option="false"
              :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
            />
            <div v-if="form.errors.business_id" class="form-error">{{ form.errors.business_id }}</div>
          </div>

<!--          <select-input v-model="form.business_id" :error="barazimForm.errors.business_id" class="pb-8 pr-6 w-full"-->
<!--                        label="Biznesi shitës"-->
<!--          >-->
<!--            <option value="null">Zgjedh biznesin</option>-->
<!--            <option v-for="business in businesses" :key="business.id" :value="business.id">{{ business.name }}</option>-->
<!--          </select-input>-->

          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="font-bold">Gjithsejt dërgesa:</label>
            <p>{{orders.data.length}}</p>
          </div>

<!--          <div class="pb-8 pr-6 w-full lg:w-1/2">-->
<!--            <label class="font-bold">Gjithsejt kthime të mjeteve:</label>-->
<!--            <p>{{moneyReturns.data.length}}</p>-->
<!--          </div>-->


          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="font-bold">Total shitje:</label>
            <currency-number-format :number="`${barazim_data.total_sales}`"></currency-number-format>
          </div>

<!--          <div class="pb-8 pr-6 w-full lg:w-1/2">-->
<!--            <label class="font-bold">Total kthime të mjeteve nga posta:</label>-->
<!--            <currency-number-format :number="`${barazim_data.total_money_return_cost}`"></currency-number-format>-->
<!--          </div>-->



          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="font-bold">Total posta:</label>
            <currency-number-format :number="`${barazim_data.total_shipping_cost}`"></currency-number-format>

          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="font-bold">Shuma NETO për dorëzim:</label>
            <currency-number-format :number="`${barazim_data.total_neto_amount}`"></currency-number-format>

          </div>

        </div>


        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="button" @click="showBarazimModal = true">Regjistro barazim</loading-button>
          <Teleport to="body">
            <!-- use the modal component, pass in the prop -->
            <modal :show="showBarazimModal" @close="showBarazimModal = false">
              <template #header>
                <h3>Zgjedhni lokacionin e shitësit ku duhet të dërgohet barazimi.</h3>
              </template>

              <template #body>

                <div class="flex flex-wrap">

                  <div  class="pb-8 pr-6 w-full lg:w-full">
                    <label class="form-label">Lokacioni:</label>
                    <select v-model="barazimForm.location_id" :error="barazimForm.errors.location_id" class="form-select focus:ring-0 hover:border-indigo-500" >
                      <option v-for="location in selectedLocations" :key="location.id" :value="location.id">{{ location.name }}</option>
                    </select>
                  </div>

                  <textarea-input v-model="barazimForm.additional_info" :error="barazimForm.errors.additional_info" class="pb-8 pr-6 w-full lg:w-full" label="Informata shtesë" />



                </div>
              </template>

              <template #footer>
                <div class="flex flex-wrap">
                  <loading-button class="btn-indigo bg-red-500"
                                  @click = "showBarazimModal = false"
                  >Anulo</loading-button>
                  <loading-button :loading="barazimForm.processing" class="btn-indigo ml-auto" type="button" @click="submitBarazimForm">Vazhdo</loading-button>
                </div>
              </template>
            </modal>
          </Teleport>
        </div>
      </form>
    </div>



    <div class="flex items-center mb-6">
      <h2 class="mt-12 text-2xl font-bold">Dërgesat e pabarazuara</h2>
    </div>

    <div class="flex flex-wrap  mb-6 lg:mb-6">
      <div class="pr-5 w-full lg:w-full mb-6">
        <search-input v-model="form.search" class="mr-4 py-0  w-full max-w-md" @reset="reset"></search-input>
      </div>

      <div class="pr-5 w-full lg:w-1/4">
        <label class="form-label">Statusi:</label>
        <Multiselect
          v-model="form.status_ids"
          :options="filterStatuses.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />
      </div>

    <div class="pr-5 w-full lg:w-1/4">
      <label class="form-label">Shteti:</label>
      <Multiselect
        v-model="form.country_ids"
        :options="filterCountries.options"
        mode="tags"
        :close-on-select="false"
        :searchable="true"
        :create-option="false"
        :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
      />
    </div>

    <div class="pr-5 w-full lg:w-1/4">
      <label class="form-label">Nga data e editimit të statusit:</label>
      <input v-model="form.start_date_status_updated" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
    </div>

    <div class="pr-5 w-full lg:w-1/4">
      <label class="form-label">Deri në datën(duke mos e përfshirë):</label>
      <input v-model="form.end_date_status_updated" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
    </div>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-2">
            <input :checked="allOrdersSelected" @click="selectAllOrders" class="flex items-center  px-2 py-4" type="checkbox">
          </th>
          <th class="pb-4 pt-6 px-2"></th>
          <th class="pb-4 pt-6 px-2">ID</th>
          <th class="pb-4 pt-6 px-2">Statusi</th>
          <th class="pb-4 pt-6 px-2">Biznesi shitës</th>
          <th class="pb-4 pt-6 px-2">Pika marrëse</th>
          <th class="pb-4 pt-6 px-2">Emri i blerësit</th>
          <th class="pb-4 pt-6 px-2">Telefoni i blerësit</th>
          <th class="pb-4 pt-6 px-2">Produkti</th>
          <th class="pb-4 pt-6 px-2">Sasia</th>
          <th class="pb-4 pt-6 px-2">Madhësia e pakos</th>
          <th class="pb-4 pt-6 px-2">Çmimi</th>
          <th class="pb-4 pt-6 px-2">Posta</th>
          <th class="pb-4 pt-6 px-2">Qyteti</th>
          <th class="pb-4 pt-6 px-2">Statusi i edituar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="order in orders.data" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100">

          <td class="border-t px-2">
            <input v-model="order.selected" :value="order.id" class="flex items-center  px-2 py-4" type="checkbox">
          </td>

          <td class="w-px border-t">
            <a class="flex items-center  px-2 py-4" :href="`/admin/dergesat/${order.id}`" target="_blank" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              <icon v-if="order.barazim_id" name="paid" class="flex-shrink-0 ml-2 w-5 h-5 fill-gray-400" />

            </a>
          </td>

          <td class="border-t px-2">
            {{ order.id }}
            <icon v-if="order.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
            <small v-if="order.is_change" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">NDËRRIM</small>
            <small v-if="order.is_recreated" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">RINISJE</small>
            <small v-if="order.parent_id" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">BASHKIM</small>
          </td>
          <td class="border-t px-2">
              <span class="mx-0.5 px-2 py-1 rounded-md text-white" v-bind:class="getOrderStatusColor(order.status.id)">
                {{ order.status.name }}</span>
          </td>
          <td class="border-t px-2">
            {{ order.business.name }}
          </td>
          <td class="border-t px-2">
            {{ order.location.name }}
          </td>
          <td class="border-t px-2">
            {{ order.name }}
          </td>
          <td class="border-t px-2">
            {{ order.phone }}
          </td>
          <td class="border-t px-2">
            {{ order.product_name }}
          </td>
          <td class="border-t px-2">
            {{ order.quantity }}
          </td>
          <td class="border-t px-2">
            {{ order.package_size.name }}
          </td>
          <td class="border-t px-2">
            {{ order.product_price }}
          </td>

          <td v-if="order.status.id === 7 || order.status.id === 8" class="border-t px-2">
            {{ order.cancellation_price }}
          </td>
          <td v-else class="border-t px-2">
            {{ order.shipping_price }}
          </td>



          <td class="border-t px-2">
            {{ order.city.name }}
          </td>
          <td class="border-t px-2">
            {{ order.updated_status_at }}
          </td>
        </tr>
        <tr v-if="orders.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="14">Nuk u gjet asnje dërgesë.</td>
        </tr>
        </tbody>
      </table>
    </div>



<!--    <div  class="flex items-center mb-6">-->
<!--      <h2 class="mt-12 text-2xl font-bold">Kthimet e mjeteve</h2>-->
<!--    </div>-->

<!--    <div class="bg-white rounded-md shadow overflow-x-auto">-->
<!--      <table class="w-full whitespace-nowrap">-->
<!--        <thead>-->
<!--        <tr class="text-left font-bold">-->
<!--          <th class="pb-4 pt-6 px-6"></th>-->
<!--          <th class="pb-4 pt-6 px-6">ID</th>-->
<!--          <th class="pb-4 pt-6 px-6">Dërgesa</th>-->
<!--          <th class="pb-4 pt-6 px-6">Kthimi i dërgesës</th>-->
<!--          <th class="pb-4 pt-6 px-6">Biznesi shitës</th>-->
<!--          <th class="pb-4 pt-6 px-6">Pika marrëse</th>-->
<!--          <th class="pb-4 pt-6 px-6">Shuma e mjeteve</th>-->
<!--          <th class="pb-4 pt-6 px-6">Posta</th>-->
<!--          <th class="pb-4 pt-6 px-6">Emri i blerësit</th>-->
<!--          <th class="pb-4 pt-6 px-6" >Telefoni i blerësit</th>-->
<!--          <th class="pb-4 pt-6 px-6" >Qyteti</th>-->
<!--          <th class="pb-4 pt-6 px-6" >Statusi</th>-->
<!--          <th class="pb-4 pt-6 px-6" >Krijuar më</th>-->
<!--        </tr>-->
<!--        </thead>-->
<!--        <tbody>-->
<!--        <tr v-for="moneyReturn in moneyReturns.data" :key="moneyReturn.id" class="hover:bg-gray-100 focus-within:bg-gray-100">-->
<!--          <td class="w-px border-t">-->
<!--            <a class="flex items-center  px-2 py-4" :href="`/admin/mjetet/${moneyReturn.id}`" target="_blank" tabindex="-1">-->
<!--              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />-->
<!--            </a>-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            {{ moneyReturn.id }}-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            <a class="flex items-center px-6 py-4 focus:text-indigo-500" target="_blank" :href="`/admin/dergesat/${moneyReturn.order_id}`">-->
<!--              {{ moneyReturn.order_id }}-->
<!--            </a>-->
<!--          </td>-->
<!--          <td  class="border-t px-2">-->
<!--            <a  class="flex items-center px-6 py-4 focus:text-indigo-500" target="_blank" :href="`/admin/nderrimet/${moneyReturn.order_change_id}`">-->
<!--              {{ moneyReturn.order_change_id}}-->
<!--            </a>-->
<!--          </td>-->
<!--          <td  class="border-t px-2">-->
<!--            {{ moneyReturn.business }}-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            {{ moneyReturn.paid_by_seller ? moneyReturn.location : 'Mjetet te mirren nga posta' }}-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            {{ moneyReturn.amount }}-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            {{ moneyReturn.shipping_price }}-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            {{ moneyReturn.client }}-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            {{ moneyReturn.phone }}-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            {{ moneyReturn.city }}-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            <span class="mx-0.5 px-2 py-1 rounded-md text-white" v-bind:class="getMoneyReturnStatusColor(moneyReturn.status_id)">{{ moneyReturn.status }}</span>-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            {{ moneyReturn.hr_created_at }}-->
<!--          </td>-->
<!--        </tr>-->
<!--        <tr v-if="moneyReturns.data.length === 0">-->
<!--          <td class="px-6 py-4 border-t" colspan="4">Nuk u gjet asnjë rekord.</td>-->
<!--        </tr>-->
<!--        </tbody>-->
<!--      </table>-->
<!--    </div>-->

  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import axios from 'axios'
import Icon from '@/Shared/Icon'
import Dropdown from '@/Shared/Dropdown'
import CurrencyNumberFormat from '@/Shared/CurrencyNumberFormat'
import SearchInput from '@/Shared/SearchInput'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import TextareaInput from '@/Shared/TextareaInput'
import Modal from '@/Shared/Modal'
import Multiselect from '@vueform/multiselect'
import mapValues from 'lodash/mapValues'

export default {
  components: {
    SearchInput,
    CurrencyNumberFormat,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    Icon,
    Dropdown,
    TextareaInput,
    Modal,
    Multiselect
  },
  layout: Layout,
  props:{
    businesses: Array,
    locations: Array,
    countries: Object,
    orders: Object,
    moneyReturns: Object,
    filters: Object,
    barazim_data: Object,
    statuses: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        business_id: this.filters.business_id ?? null,
        search: this.filters.search,
        country_ids: this.filters.country_ids,
        start_date_status_updated: this.filters.start_date_status_updated,
        end_date_status_updated: this.filters.end_date_status_updated,
        status_ids: this.filters.status_ids
      }),
      barazimForm: this.$inertia.form({
        business_id: this.filters.business_id ?? null,
        location_id: null,
        additional_info: null,
        currentOrderSelections: null,
        country_ids: null,
        start_date_status_updated: null,
        end_date_status_updated: null,
        search: null,
        status_ids: null
      }),
      selectedLocations: this.locations,
      showBarazimModal: false,
      filterCountries: {
        options: this.countries.map(function(country){
          return {value: country.id, label: country.name}
        }),
      },
      filterBusinesses: {
        options: this.businesses.map(function(business){
          return {value: business.id, label: business.name}
        }),
      },
      filterStatuses: {
        options: this.statuses.map(function(status){
          return {value: status.id, label: status.name}
        }),
      },

    }
  },
  created(){
    this.getLocations()
  },
  mounted() {
    this.orders.data.forEach((order) => order['selected'] = false);
  },
  computed:{
    allOrdersSelected(){
      return this.orders.data.every(order => order.selected)
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/admin/financat/barazimet-me-shites/regjistro',pickBy(this.form),{
          preserveScroll: true,
          preserveState: true,
        })
        this.barazimForm.business_id = this.form.business_id
        this.barazimForm.country_ids = this.form.country_ids
        this.barazimForm.start_date_status_updated = this.form.start_date_status_updated
        this.barazimForm.end_date_status_updated = this.form.end_date_status_updated
        this.barazimForm.search = this.form.search
        this.barazimForm.status_ids = this.form.status_ids
        this.getLocations()
      }, 150)
    },
    orders: {
      handler() {
        this.barazimForm.currentOrderSelections = this.orders.data
          .filter( order => order.selected )
          .map( order => order.id )
          .toString();
      },
      deep: true
    },
  },
  methods: {
    reset(){
      this.form.start_date_status_updated = null
      this.form.end_date_status_updated = null
      this.form.search = null
      let multiselectClearButtons = document.getElementsByClassName('multiselect-clear')
      for(let i = 0 ; i < multiselectClearButtons.length; i++){
        multiselectClearButtons[i].click()
      }
    },
    submitBarazimForm(){
      this.barazimForm.post('/admin/financat/barazimet-me-shites')
    },
    selectAllOrders(){
      let allS = this.allOrdersSelected;
      this.orders.data.forEach(order => order.selected = !allS)
    },
    getLocations(){
      let self = this
      self.selectedLocations = []
      axios.get('/ajax/list/locations', {
        params: {
          business_id: this.form.business_id,
        },
      }).then(function (result) {
        self.selectedLocations = result.data.locations
        self.barazimForm.location_id = result.data.locations[0].id
      })
    },
    getOrderStatusColor(statusId){
      let statusColor = 'bg-indigo-500'
      if(statusId === 1)
        statusColor = 'bg-yellow-500'

      if(statusId === 3)
        statusColor = 'bg-orange-500'

      if(statusId === 4)
        statusColor = 'bg-indigo-900'

      if(statusId === 5)
        statusColor = 'bg-green-500'

      if(statusId === 6)
        statusColor = 'bg-yellow-700'

      if(statusId === 7)
        statusColor = 'bg-red-500'

      if(statusId === 8)
        statusColor = 'bg-gray-400'

      if(statusId === 9)
        statusColor = 'bg-green-500'

      return statusColor
    },
    getMoneyReturnStatusColor(moneyReturnStatusId){
      let color = 'bg-indigo-500'
      if (moneyReturnStatusId === 1)
        color = 'bg-yellow-500'

      if (moneyReturnStatusId === 3)
        color = 'bg-orange-500'

      if (moneyReturnStatusId === 4)
        color = 'bg-indigo-900'

      if (moneyReturnStatusId === 5)
        color = 'bg-green-500'

      if (moneyReturnStatusId === 6)
        color = 'bg-red-500'


      return color
    },
  },

}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
